import React from 'react';


export default function ArrowUpIcon() {
  return (
   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_12083_1846)">
<path d="M18 12L12 6L6 12M12 6V18" stroke="#071013"/>
</g>
<defs>
<clipPath id="clip0_12083_1846">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

  )
}
